<template>
  <div class="table-responsive" id="forecast-table" :class="{'scrollShow' : showScroll, 'scrollHide' : !showScroll}">
    <table class="table tablesorter">
      <tbody>
      <tr>
        <td v-for="(value, index) in forecast.list" :key="index" style="min-width: 70px;">
          <forecast-item :weather="value" :timezone="forecast.city.timezone"></forecast-item>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
    import ForecastItem from "./ForecastItem";
    export default {
      components: {ForecastItem},
      props: ['forecast', 'showScroll'],
      name: "ForecastTable"
    }
</script>

<style scoped>
  .scrollShow{
    overflow: auto;
  }
  .scrollHide{
    overflow: hidden;
  }
</style>
